import React from 'react'
import { StyleSheet } from 'react-native'

import { DNABox, Stack, DNAText, DNAButton } from '@alucio/lux-ui';

import BeaconEmptyStateImage from 'src/assets/images/BeaconEmptyState'

const S = StyleSheet.create({
  labelText: {
    fontSize: 15,
    color: '#64748B',
    fontWeight: '600',
  },
})

const HubsTemplateSelectEmpty: React.FC<{
  handleCreateHubs: () => void
}> = ({ handleCreateHubs }) => {
  return (
    <DNABox fill>
      <Stack anchor="center">
        {/* IMAGE */}
        <Stack.Layer anchor="center" alignSelf="center">
          <BeaconEmptyStateImage
            height={320}
            width={320}
          />
        </Stack.Layer>
        {/* LABEL & ACTION BUTTON */}
        <Stack.Layer anchor="bottom">
          <DNABox appearance="col" alignX="center" spacing="lg">
            <DNAText testID="empty-content-placeholder" style={S.labelText}>
              No templates available
            </DNAText>
            <DNAButton
              testID="hub-table-header-create-hub-btn"
              size="lg"
              onPress={handleCreateHubs}
              children="Create hub"
            />
          </DNABox>
        </Stack.Layer>
      </Stack>
    </DNABox>
  )
}

export default HubsTemplateSelectEmpty
